//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetContactsResponse } from './models/GetContactsResponse';
import { Utilities } from './Utilities';

export class UsersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getContacts: (
			search?: string,
        ): string => {
            let clientRequestUrl = '/api/v3/users/me/contacts?';
            if (search === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('search'));
            } else if (search !== undefined) {
                clientRequestUrl += `search=${encodeURIComponent(String(search))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        changeLanguage: (
			language: string,
        ): string => {
            let clientRequestUrl = '/api/v3/users/me/do-change-language/{language}';
            if (language === undefined || language === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('language'));
            }
            clientRequestUrl = clientRequestUrl.replace('{language}', encodeURIComponent(String(language)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getIntroTour: (): string => {
            let clientRequestUrl = '/api/v3/users/me/introduction-tour';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Returns top 5 contacts (alphabetically) matching the search term
     * @param search (optional) search term
     * @return OK
     */
    async getContacts(
        search?: string,
    ): Promise<GetContactsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getContacts(
            search,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetContactsResponse>(_response, false, []);
    }

    /**
     * Change preferred language of current user
     * @return The update was successful
     */
    async changeLanguage(
        language: string,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.changeLanguage(
            language,
        );

        const options = {
            method: 'PUT',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Returns the intro tour contents for the connected user
     * @return OK
     */
    async getIntroTour(): Promise<any> {
        const clientRequestUrl = this.baseUrl + this.routes.getIntroTour();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<any>(_response, false, [/* any */]);
    }
}
